import React from "react";
import { TagRoom } from "@/components/TagRoom";

const HERO = "https://static.prod-images.emergentagent.com/jobs/0e3d4d61-ed21-4f86-b551-f282d91748f8/images/a4d986ef0c973061cae7fd52f332869c443c449b839cc082bd6ffa0a00ba8763.jpeg";

export default function BhavanaKamare() {
  return <TagRoom titleKey="bh_title" subKey="bh_sub" heroImg={HERO} tag="bhavana" testid="bhavana" />;
}
